module.exports = __webpack_public_path__ + "static/media/Fund Statement.87b42ed2.png";